import { ErrorCircleColored } from "components/icons/generated";
import SystemMessage from "components/SystemMessage";
import Button from "ds/components/Button";

const ErrorBoundaryFallback = () => (
  <SystemMessage
    title="Something went wrong"
    message="Please try to reload the page"
    icon={ErrorCircleColored}
  >
    <Button variant="primary" onPress={() => window.location.reload()} fullWidth>
      Reload
    </Button>
  </SystemMessage>
);

export default ErrorBoundaryFallback;
